// API Client für Verträge (contracts)
import { buildApiUrl } from "../lib/api";
import { getAuthHeaders } from "./auth";

export interface Contract {
    _id: string;
    contractNumber: string; // entspricht VERTRAG im Transport
    LIFNR: string; // Lieferantennummer
    [key: string]: unknown;
}

export async function fetchContractByNumber(contractNumber: string): Promise<Contract | null> {
    const url = buildApiUrl("/api/contracts", { contractNumber });
    const response = await fetch(url, {
        headers: getAuthHeaders(),
        credentials: "include"
    });
    if (!response.ok) return null;
    const data = await response.json();
    if (Array.isArray(data) && data.length > 0) return data[0] as Contract;
    return null;
}

/**
 * Holt den LIFNR (Lieferantennummer) für eine Vertragsnummer
 * Wird benötigt, um primäre Ladeorte zu laden
 */
export async function fetchLIFNRByContractNumber(contractNumber: string): Promise<string | null> {
    try {
        const url = buildApiUrl("/api/contracts", { VERTRAG: contractNumber });
        const response = await fetch(url, {
            headers: getAuthHeaders(),
            credentials: "include"
        });

        if (!response.ok) {
            return null;
        }

        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
            const contract = data[0] as { LIFNR?: string };
            return contract.LIFNR || null;
        }

        return null;
    } catch (error) {
        console.error("Error fetching LIFNR for contract:", error);
        return null;
    }
}
